/**
 * app-config/query-keys — TanStack Query key factory for CONFIG_OVER_CODE.
 * Same contract as `utils/query-keys.ts`: never inline arrays at the call site.
 */

export const appConfigQueryKeys = {
  all: ["app-config"] as const,
  /** Public config reflected by client (`GET /api/config`). */
  public: () => ["app-config", "public"] as const,
  /** Back-office panel (`GET /api/admin/config`). */
  admin: () => ["admin", "config"] as const,
};
